import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../../../filters';

import users from '../../../../users';

import { validationMixin } from 'vuelidate';
import { required, minValue } from 'vuelidate/lib/validators';

export default {
  name: 'adjustmentBetweenCustomers',
  mixins: [users, validationMixin],
  components: {

  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      effectiveDataView: null
    }
  },
  validations: {
    dataObj: {
      appData: {
        amount: {
          required,
          minValue: minValue(0.01)
        },
        consumption: {
          minValue: minValue(0)
        }
      }
    }
  },
  watch: {
    effectiveDataView: function (val) {
      this.dataObj.appData.effectiveData = moment(val, "DD/MM/YYYY").add(1, 'days');
    }
  },
  created() {
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.$root.$on('adjustment_between_customers_updated', this.init);
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;
        this.effectiveDataView = this.$options.filters.formatDateDDMMYYY(this.dataObj.appData.effectiveData);
      });
    },
    reverseCustomers() {
      this.dataObj.appData.reverseCustomers = !this.dataObj.appData.reverseCustomers;

      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
        Item: JSON.parse(JSON.stringify(this.dataObj.appData))
      };

      this.$store.state.notifier.asyncBlock(
        axios.post('/AdjustmentBetweenCustomersActivity/ReverseCustomers', parameter),
        resp => {
          this.dataObj.debitCustomAsOwnerVisible = resp.data.item.debitCustomAsOwnerVisible;
          this.dataObj.creditCustomerAsOwnerVisible = resp.data.item.creditCustomerAsOwnerVisible;
          this.dataObj.debitCustomerProperties = resp.data.item.debitCustomerProperties;
          this.dataObj.creditCustomerProperties = resp.data.item.creditCustomerProperties;
          this.dataObj.ageings = resp.data.item.ageings;
          this.effectiveDataView = this.$options.filters.formatDateDDMMYYY(resp.data.item.effectiveData);
          this.dataObj.appData = resp.data.item;
          this.dataObj.readOnly = resp.data.readonly;

          this.$alertMsg(this.$t('messages.ReverseCustomerSuccess'),2);
        },
        err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text)
      );
    },
    getValidationClass(main1, main2, fieldName) {
      const field = this.$v[main1][main2][fieldName];

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    validateAppData() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        return true;
      }
      else {
        return false;
      }
    }
  },
}
